import { BaseUser, ExtendedUser } from "./common.types";

// Base user interfaces
export interface User extends ExtendedUser {
  OrgId: string;
  FirstName: string;
  LastName: string;
  ImagePath?: string;
  LastUsed?: string;
  Created: string;
  CreatedBy: number;
  Changed?: string;
  ChangedBy?: number;
  Status: boolean;
  EntityNo?: number;
}

export interface Employee {
  ExternalUserNo: number;
  Name: string;
  Firstname: string;
  Lastname: string;
  FirstName: string; // Alias for Firstname
  LastName: string;   // Alias for Lastname
  ImagePath: string | null;
  Status: boolean;
  OrgId: string;
  LastUsed: string | null;
  Roles: Array<{
    RoleType: number;
  }>;
  Error: boolean;
  ErrorCode: number | null;
  ErrorMessage: string | null;
  ContactPersonData: ContactPersonData | null;
}

export interface ContactPersonData {
  Name: string;
  Title: string;
  Phone: string;
  Email: string;
  ImageName: string;
  ImageData: string;
}

// Current user for authenticated session
export interface CurrentUser {
  CompanyNo: number;
  CompanyName: string;
  CompanyShortName: string;
  Name: string;
  Firstname: string;
  Lastname: string;
  ExternalUserId: number;
  Roles: CurrentUserRole[];
  Teams: Team[];
  ContactPersonData: ContactPersonData | null;
  HaveCustomers: boolean;
  MyOrgId: string;
  ImagePath?: string | null;
  MaxSwishOut?: number;
}

// Team-related types
export interface Team {
  Id: number;
  Name: string;
  Description?: string;
}

export interface UsersTeam extends Team {
    Users: BaseUser[];
    UserIds: number[];
    TeamSelectable: boolean;
}

export interface TeamWithUsers extends Team {
  TeamSelectable?: boolean;
  Users?: BaseUser[];
}

// Role-related types
export interface Role {
  Type: UserRoleType;
  Name: string;
}

export interface CurrentUserRole extends Role {
  Id: number;
  Data: string;
}

export interface UserRole {
  Id: number;
  RoleType: UserRoleType;
  RoleName: string;
}

export interface UserTeam {
  Id: number;
  Name: string;
  Role?: string;
}

// User role types enum
export enum UserRoleType {
  Default = 0,
  Customer = 1,
  Employee = 2,
  Crm = 3,
  Admin = 4,
  ZynergyUser = 5,
  NavHubPublisher = 6,
  PuzzelUser = 7,
  CrmAdmin = 8,
  SalesPerson = 9,
  SalesAdmin = 10,
  ExternalSale = 11,
  ExternalSaleAdmin = 12,
  Agent = 13,
  AdminSendSms = 14,
  SwishOut = 15,
  SpecialFunctions = 16,
  MarkavtalUtbetalning = 17,
  FiberFacilityHandling = 18,
  FixedVolumeAdmin = 19,
  ApsisAdmin = 20,
  ExternalPartner = 21,
  TransactionAdmin = 22,
  DeSupplierHandling = 23,
  AppAdmin = 24,
  Leads = 25,
  ShowArchivedCustomerData = 26,
  RotRutAdmin = 27,
  SuperAdmin = 28,
}

// Sales responsible type
export interface SalesResponsible {
  ExternalUserNo: number;
  Name: string;
  ContactPersonData: ContactPersonData | null;
}

// User list types for dropdowns/selections
export interface UserList extends BaseUser {
  GivenName?: string;
  UserId?: string;
  CompanyNo?: number;
}
